module.exports = __webpack_public_path__ + "images/icon_input_selectbox_80a4cb1247ef143763adfb5497656cfb.png";